import { FormProps } from '@deltek/specification-client/core/Models/formProps'
import { ContentLibrary } from '@deltek/specification-client/core/Models/product'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { AutoCompleteInput } from 'bpm/pages/ProductsPage/AddProductDialog/AutoCompleteInput'
import React, { useCallback } from 'react'
import { ProductListingDetailFormField } from '../ListingDetailsPage'

const useStyles = makeStyles((theme: Theme) => ({
    container: { paddingTop: theme.spacing(2) },
    inputRoot: {
        borderRadius: 4,
    },
    input: {
        fontSize: pxToRem(36),
        fontWeight: 500,
        color: '#211F20',
    },
}))

interface EditContentLibraryProps extends FormProps {
    handleFieldChange: (
        field: ProductListingDetailFormField,
        value: string
    ) => void
}

export const EditContentLibrary: React.FC<EditContentLibraryProps> = ({
    value,
    valid,
    required,
    handleFieldChange,
}) => {
    const classes = useStyles()
    const options = Object.entries(ContentLibrary).map(([key, value]) => ({
        key,
        value,
    })) as Record<string, string>[]
    const [localValue, setLocalValue] = React.useState<Record<string, string>>(
        options.filter((x) => x.value === value)[0]
    )

    const debouncedInput = React.useCallback(
        (val: Record<string, string>) => {
            setLocalValue(val)
            handleFieldChange('contentLibrary', val.key)
        },
        [handleFieldChange]
    )

    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        debouncedInput(value)
    }
    const handleInputChange = useCallback(() => {}, [])

    return (
        <div className={classes.container}>
            <AutoCompleteInput
                name={'Product Family'}
                items={options}
                handleChange={handleChange}
                handleInputChange={handleInputChange}
                valid={valid}
                selectedValue={localValue}
                disableClearable={true}
                getOptionSelected={(option, val) => option.key === val.key}
                getOptionLabel={(option) => option.value}
            />
        </div>
    )
}
